import {
  Directive,
  ElementRef,
  Renderer2,
  HostListener,
  OnInit,
  OnDestroy,
} from '@angular/core'

@Directive({
  selector: 'input[showPassword]',
})
export class ShowPasswordDirective implements OnInit, OnDestroy {
  private toggleEl: HTMLElement
  private visible = false
  private clickUnlisten: () => void

  constructor(
    private _el: ElementRef<HTMLInputElement>,
    private _renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    const input = this._el.nativeElement
    const parent = input.parentElement
    if (!parent) {
      return
    }

    this._renderer.setStyle(parent, 'position', 'relative')
    this._renderer.setStyle(input, 'paddingRight', '38px')

    this.toggleEl = this._renderer.createElement('span')
    this._renderer.addClass(this.toggleEl, 'glyphicon')
    this._renderer.addClass(this.toggleEl, 'glyphicon-eye-open')
    this._renderer.addClass(this.toggleEl, 'show-password-toggle')
    this._renderer.setAttribute(this.toggleEl, 'role', 'button')
    this._renderer.setAttribute(this.toggleEl, 'tabindex', '-1')
    this._renderer.setAttribute(this.toggleEl, 'title', 'Prikaži/sakrij lozinku')
    this._renderer.setAttribute(this.toggleEl, 'aria-label', 'Prikaži/sakrij lozinku')
    this._renderer.setStyle(this.toggleEl, 'position', 'absolute')
    this._renderer.setStyle(this.toggleEl, 'right', '12px')
    this._renderer.setStyle(this.toggleEl, 'top', '50%')
    this._renderer.setStyle(this.toggleEl, 'transform', 'translateY(-50%)')
    this._renderer.setStyle(this.toggleEl, 'cursor', 'pointer')
    this._renderer.setStyle(this.toggleEl, 'opacity', '0.65')
    this._renderer.setStyle(this.toggleEl, 'zIndex', '5')

    this._renderer.appendChild(parent, this.toggleEl)

    this.clickUnlisten = this._renderer.listen(this.toggleEl, 'click', () =>
      this.toggle(),
    )
  }

  private toggle(): void {
    this.visible = !this.visible
    const input = this._el.nativeElement
    this._renderer.setAttribute(input, 'type', this.visible ? 'text' : 'password')
    if (this.visible) {
      this._renderer.removeClass(this.toggleEl, 'glyphicon-eye-open')
      this._renderer.addClass(this.toggleEl, 'glyphicon-eye-close')
    } else {
      this._renderer.removeClass(this.toggleEl, 'glyphicon-eye-close')
      this._renderer.addClass(this.toggleEl, 'glyphicon-eye-open')
    }
  }

  @HostListener('copy', ['$event'])
  @HostListener('cut', ['$event'])
  @HostListener('contextmenu', ['$event'])
  blockCopy(e: Event): boolean {
    e.preventDefault()
    return false
  }

  ngOnDestroy(): void {
    if (this.clickUnlisten) {
      this.clickUnlisten()
    }
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-login/show-password.directive.ts